import { downloadBlob } from '@/utils/downloadBlob';

const toCsvCell =(value) => `"${String(value ?? '').replace(/"/g, '""')}"`;

/**
 * Downloads rows as `<fileName>_Data_Extract.csv`: a header row of each column's headerName,
 * then one row per item with getValue(column, row) for each column. Every value is quoted.
 */
export const downloadCsv = ({ columns, rows, getValue, fileName }) => {
	const csvRows = [
		columns.map((column) => toCsvCell(column.headerName)).join(','),
		...rows.map((row) => columns.map((column) => toCsvCell(getValue(column, row))).join(',')),
	];

	downloadBlob(
		new Blob([csvRows.join('\n')], { type: 'text/csv;charset=utf-8;' }),
		`${fileName}_Data_Extract.csv`,
	);
};
